import React from 'react';
import ContentContainer from '../../components/LayoutComponents/ContentContainer';
import ImportWriteoffsConfirm from '../../components/CbsComponents/Imports/Writeoffs/ImportWriteoffsConfirm';

const ImportWriteoffsTable: React.FC = () => {
  const breadcrumbs = [
    {
      title: 'menu.imports',
      href: '#',
    },
    {
      title: 'menu.importCollectorLoans',
      href: `/import/writeoffs`,
    },
  ];
  return (
    <ContentContainer
      helmetTitle="menu.importDisbursements"
      pageTitle="menu.imports"
      breadcrumbs={breadcrumbs}
    >
      <ImportWriteoffsConfirm />
    </ContentContainer>
  );
};

export default ImportWriteoffsTable;
